import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Table,
  FormGroup,
  Label,
  Input,
  Button,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import Pagination from 'components/Pagination';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import CreateAndEditWebhookConfig from '../components/ModalCreateWebhookConfig';
import { HeaderWebhookConfig } from '../components/HeaderWebhookConfig';
import WebhookConfigService from '../services/WebhookConfigService';
import { toast } from 'react-toastify';

const WebhookConfig = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [WebhookConfigFromUpdate, setWebhookConfigFromUpdate] = useState({});
  const [WebhookConfig, setWebhookConfig] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalWebhookConfig, setTotalWebhookConfig] = useState(0);
  const [showIsEnable, setShowIsEnable] = useState(true);
  const [search, setSearch] = useState('');
  const eventOptions = [
    { id: 'conversa_encerrada', name: 'Conversa Encerrada' },
    { id: 'conversa_iniciada', name: 'Conversa Iniciada' },
    {
      id: 'conversa_transferida_para_atendente',
      name: 'Conversa Transferida'
    },
    { id: 'atendente_enviou_mensagem', name: 'Atendente Enviar Mensagem' },
    { id: 'cliente_enviou_mensagem', name: 'Cliente Enviar Mensagem' }
  ];

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const disabledWebhookConfig = (id, name, IsEnable) => {
    WebhookConfigService.changeStatus(id)
      .then(() => {
        toast.success(
          `WebHook ${name ? name : ''} ${
            !IsEnable ? 'habilitada' : 'desabilitada'
          }`
        );
        getWebhookConfig();
      })
      .catch(() => {
        toast.error(
          `Erro ao ${!IsEnable ? 'Desabilitar' : 'Habilitar'} WebHook ${
            name ? name : ''
          }`
        );
      });
  };

  useEffect(() => {
    getWebhookConfig(1, search);
  }, [search]);

  const getWebhookConfig = (newPage, name) => {
    WebhookConfigService.getWithPagination({
      page: newPage || activePage,
      isEnable: showIsEnable,
      name
    }).then((response) => {
      setWebhookConfig(response.data.data);
      setTotalWebhookConfig(response.data.totalRegisters);
    });
  };

  const goToPage = (newPage) => {
    setActivePage(newPage);
    getWebhookConfig(newPage, search);
  };

  useEffect(() => {
    getWebhookConfig(1, search);
  }, [showIsEnable]);

  return (
    <>
      <CreateAndEditWebhookConfig
        isModalOpen={modalOpen}
        onModalToggle={setModalOpen}
        WebhookConfigFromUpdate={WebhookConfigFromUpdate}
        getWebhookConfig={getWebhookConfig}
      />

      <HeaderWebhookConfig
        onClickCreateWebhookConfig={() => {
          setWebhookConfigFromUpdate(null);
          toggleModal();
        }}
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Configurar WebHook</h3>
                </CardHeader>
                <Row className="mt-3 mx-2">
                  <Col md="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Busca WebHook pelo titulo"
                        value={search}
                        type="text"
                        defaultValue=""
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="12" className="text-right mt-2 mt-md-1">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={!showIsEnable}
                          onChange={() => setShowIsEnable(!showIsEnable)}
                        />
                        <span>Mostrar desabilitados</span>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <CardBody>
                  <Table hover={true} striped>
                    <thead>
                      <tr>
                        <th className="text-center">Nome</th>
                        <th className="text-center">Evento</th>
                        <th className="text-center">Desabilitar/Habilitar</th>
                        <th className="text-center">Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {WebhookConfig.length &&
                        WebhookConfig.map((item, index) => (
                          <tr key={index}>
                            <td className="text-center">{item.name}</td>
                            <td className="text-center">
                              {eventOptions.find(
                                (event) => event.id === item.event
                              )?.name || item.event}
                            </td>
                            <td className="text-center">
                              <ToggleSwitch
                                checked={item.isEnable}
                                id={item.id}
                                onChange={() =>
                                  disabledWebhookConfig(
                                    item.id,
                                    item.name,
                                    item.isEnable
                                  )
                                }
                              />
                            </td>
                            <td className="text-center">
                              <Button
                                color="info"
                                onClick={() => {
                                  setWebhookConfigFromUpdate(item);
                                  toggleModal();
                                }}
                                size="sm"
                              >
                                <li className="fas fa-user-edit"></li>
                              </Button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </CardBody>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={totalWebhookConfig}
                  onChange={goToPage.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default WebhookConfig;
